import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { ExpansionDefinition } from "slotworks/model/gameplay/records/spin-record";
import { SoundEvent } from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contract";
import { parallel } from "slotworks/utils/race-utils";
import { sequence } from "slotworks/utils/race-utils";

export default class ExpandSymbols extends State {

    protected sequence: boolean = false;

    protected isComplete: boolean = false;

    private sourceSymbolId: string;

    public onEnter() {
        this.isComplete = false;

        const spinRecord = GameState.getCurrentGame().getCurrentRecord() as SpinRecord;
        const expansions = spinRecord.expansions;

        const expands = [];

        for (const expansion of expansions) {
            expands.push(() => this.expand(expansion));
        }

        if (this.sequence) {
            sequence(expands).then(() => this.expandsComplete());
        } else {
            parallel(expands).then(() => this.expandsComplete());
        }
    }

    public onSkip() {
        SoundManager.event(SoundEvent.skip_expands);
        this.expandsComplete();
    }

    protected expand(expansion: ExpansionDefinition): Contract<void> {
        const sourceSymbol = Components.matrix.getSymbol(expansion.source.x - 1, expansion.source.y - 1);
        const targetSymbol = Components.matrix.getSymbol(expansion.target.x - 1, expansion.target.y - 1);

        this.sourceSymbolId = sourceSymbol.symbolId;

        const direction = targetSymbol.gridPosition.y - (sourceSymbol.gridPosition.y - sourceSymbol.getStackOffset());

        return sourceSymbol.expand(0, direction);
    }

    protected expandsComplete() {
        if (!this.isComplete) {
            this.isComplete = true;

            const spinRecord = GameState.getCurrentGame().getCurrentRecord() as SpinRecord;
            const expansions = spinRecord.expansions;

            for (const expansion of expansions) {
                for (const position of expansion.expansions) {
                    const symbol = Components.matrix.getSymbol(position.x - 1, position.y - 1);
                    symbol.static();
                    symbol.setSymbol("expanded_" + this.sourceSymbolId);
                }
            }

            Components.matrix.flush();

            this.complete();
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/expand-symbols.ts